module.exports = __webpack_public_path__ + "img/image-01.dd001423.jpeg";